import $ from 'jquery';
import Breakpoint from 'Utils/breakpoint-dispatcher';
import PubSub from 'Utils/pub-sub';
import {initMenu} from './header2';
import {initHeaderLhsUnauthMobile} from './headerLhsUnauth';
import {initHeaderLhsUnauthDesktop} from './headerLhsUnauth';
import {initHeaderLhsAuthDesktop} from './headerLhsAuth';
import {initHeaderLhsAuthMobile} from './headerLhsAuth';
import HeaderAuth from './HeaderAuth';
import Sidedrawer from '../sidedrawer/sidedrawer';

const BREAKPOINT_DESKTOP = Breakpoint.breakpoint.DESKTOP;
const BREAKPOINT_TABLET = Breakpoint.breakpoint.TABLET;
const BREAKPOINT_MOBILE = Breakpoint.breakpoint.MOBILE;

const AUTH_STATE = {
  AUTH: 'AUTH',
  NO_AUTH: 'NO_AUTH'
};

const HEADER_SELECTOR = {
  SIDEDRAWER_AUTH: '.js-header-auth',
  HEADER_LHS_AUTH : '.js-header-lhs-auth',
  HEADER_LHS_UNAUTH: '.js-header-lhs-no-auth',
  SIDEDRAWER_NO_AUTH: '.js-header',
  AUTH: '.js-menu-auth',
  NO_AUTH: null
};

var headerInstance = null;
var headerInstanceLhs = null;
var isMobile;
var viewState = "";

const HeaderFactory = function () {

  return {
    init() {
      Breakpoint.start();
      setInitialContext();
    }
  }
}();

function setInitialContext() {
  var isContextLHS = false;

  if (($(HEADER_SELECTOR.HEADER_LHS_UNAUTH).length > 0)
    || ($(HEADER_SELECTOR.HEADER_LHS_AUTH).length > 0 )) {
    isContextLHS = true;
  }

  if (isContextLHS) {
	$("body").append("<span id='viewState' style='display:none'></span>");
    performLHSContext();
	PubSub.subscribe('resize:mobile', performLHSContext);
	PubSub.subscribe('resize:tablet', performLHSContext);
	PubSub.subscribe('resize:desktop', performLHSContext);
  } else {
    performOldNav();
  }
}

function performLHSContext() {
	viewState = Breakpoint.getState();
	$('#viewState').text(viewState);
    switch (viewState) {
        case BREAKPOINT_MOBILE:
        case BREAKPOINT_TABLET:

            if ($(HEADER_SELECTOR.HEADER_LHS_AUTH).length > 0) {
                initHeaderLhsAuthMobile();
                break;
            }

            if($(HEADER_SELECTOR.HEADER_LHS_UNAUTH).length > 0 ){
                initHeaderLhsUnauthMobile(HEADER_SELECTOR.HEADER_LHS_UNAUTH);
                break;
            }

        case BREAKPOINT_DESKTOP:
            if ($(HEADER_SELECTOR.HEADER_LHS_AUTH).length > 0) {
                initHeaderLhsAuthDesktop();
                break;
            }

            if($(HEADER_SELECTOR.HEADER_LHS_UNAUTH).length > 0 ){
                initHeaderLhsUnauthDesktop(HEADER_SELECTOR.HEADER_LHS_UNAUTH);
                break;
            }
    }
}


function performOldNav() {
    switch (Breakpoint.getState()) {
        case BREAKPOINT_MOBILE:
            isMobile = true;

            if ($('.js-menu').length > 0) {
                headerInstance = new Sidedrawer(HEADER_SELECTOR.SIDEDRAWER_NO_AUTH);
            } else  {
                headerInstance = new Sidedrawer(HEADER_SELECTOR.SIDEDRAWER_AUTH);
            }

            break;

        case BREAKPOINT_DESKTOP:
        case BREAKPOINT_TABLET:
            isMobile = false;

            if ($('.js-menu').length > 0) {
                headerInstance = initMenu();
            } else {
                headerInstance = new HeaderAuth($(HEADER_SELECTOR.AUTH));
            }
            break;
    }
    handleBreakPointChange();
}

function handleBreakPointChange() {
  PubSub.subscribe('resize:mobile', handleMobileBreakPoint);
  PubSub.subscribe('resize:tablet', handleTabletBreakPoint);
  PubSub.subscribe('resize:desktop', handleTabletBreakPoint);
}

function handleMobileBreakPoint() {
  isMobile = true;
  headerInstance.destroy();

  if (headerInstance.authState === AUTH_STATE.AUTH) {
    headerInstance = new Sidedrawer(HEADER_SELECTOR.SIDEDRAWER_AUTH);
  } else {
    headerInstance = new Sidedrawer(HEADER_SELECTOR.SIDEDRAWER_NO_AUTH);
  }
}

function handleTabletBreakPoint() {
  if (!isMobile) return;
  isMobile = false;

  headerInstance.destroy();

  if (headerInstance.authState === AUTH_STATE.AUTH) {
    headerInstance = new HeaderAuth($(HEADER_SELECTOR.AUTH));
  } else {
    headerInstance = initMenu(HEADER_SELECTOR.NO_AUTH);
  }  
}

export default HeaderFactory;


// WEBPACK FOOTER //
// ./src/components/header/index.js